import React, { useEffect, useState } from "react";
import Menu from "../../nav/menu";
import Footer from "../../nav/footer";
import LoadingScreen from '../../components/loading';
import useMedia from 'use-media';
import CarroucelImg from "../../components/carroucelImg";
import './ourProviders.css';
import { textNormalSize, parseList, textInResolution, textInResolutionMobile  } from '../../multiFunctions';
import { generalStyleDivs } from '../../styles.js';
import { detaillsProviders } from '../../endpoints-Calls/providers/index.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTextHeight, faLocationPin, faHouseChimneyUser, faMortarPestle, faFireFlameCurved, faLeaf, faMugHot, faTags, faWeightHanging, faBoxOpen, faBoxesStacked, faUser } from '@fortawesome/free-solid-svg-icons';

function OurProvidersPage() {
  const isLargeScreen = useMedia("(min-width: 601px)");
  const isSmallScreen = useMedia("(max-width: 600px)");
  
  let screenSize = {
    width: window.screen.width,
    height: window.screen.height
  }

  let sizeFont = {
    fontSize: textNormalSize
  }

  let decorationOfCards = {
    margin: "10px",
  }

  let mobileSpacing = {
   marginTop: "10px",
  }

  let styleDesktop = {
    fontSize: textNormalSize
  }
  const [currentProvider, setCurrentProvider] = useState(null);
  const [isLoading, setisLoading] = useState(true);
  useEffect(() => {
    const getProvidersData = async () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const visibleCode = urlParams.get('visibleCode');
      const data = await detaillsProviders(visibleCode);
      if (data.isOk) {
        setCurrentProvider(data);
        setisLoading(false);
      } else {
        setCurrentProvider(null);
        setisLoading(false);
      }
    }
    getProvidersData();
    
  }, []);
  let iconsStyles = {
    fontSize: textInResolution("20px", "30px", "40px", "40px", screenSize),
    color: "#8B4513"
  }

  let iconsStylesMovile = {
    fontSize: textInResolutionMobile("20px", "20px", "20px", screenSize),
    color: "#8B4513"
  }
  let imageProductStyleMobile = {
    minWidth: textInResolution("150px", "200px", "220px", "220px", screenSize),
    width: textInResolution("150px", "200px", "220px", "220px", screenSize),
  }
  return (
    <>
      <Menu />
      {isLoading && <LoadingScreen/> }
      {currentProvider != null && 
        <>
        {isLargeScreen && 
          <>
          <div style={{ backgroundColor: "#F4DFBB", display: "flex", justifyContent: "center"  }}>
            <div id="mainArea" style={{ flexFlow: "column", display: "flex", minHeight: screenSize.height, maxWidth: "1200px", backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat" }}>
              <div style={{ display: "flex", flexFlow: "column", ...generalStyleDivs, ...decorationOfCards }} >
                <div  style={{ display: "flex", flexFlow: "row" }}>
                  <div style={{ display: "flex", alignItems: "center", width: "20%", justifyContent: "center" }}>
                    <img src={currentProvider.providersObj.logoURL} style={{ ...imageProductStyleMobile }} alt='' />
                  </div>
                  <div style={{ display: "flex", flexFlow: "row", width: "100%"  }}>
                    <div style={{ display: "flex", flexFlow: "column", width: "50%", ...styleDesktop }} className="parentDivRight">
                      <div style={{  padding: "5px" }}>
                        <div style={{ display: "flex", flexFlow: "row", alignItems: "center"  }}><FontAwesomeIcon icon={faUser} style={{ ...iconsStyles }}/> Producer</div>
                      </div>
                      <div style={{ padding: "5px", textAlign: "justify" }}>
                        <div>{currentProvider.providersObj.smallDescription}</div>
                      </div>
                    </div>
                    <div style={{ width: "50%", ...styleDesktop }}>
                      <div style={{ visibility: "hidden", padding: "5px" }}>
                        <FontAwesomeIcon icon={faUser} style={{ ...iconsStyles }}/>
                      </div>
                      <div style={{ padding: "5px", textAlign: "justify" }}>
                        <div>{currentProvider.providersObj.description}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", padding: "10px" }} >
                  <span><FontAwesomeIcon icon={faUser} style={{ ...iconsStyles }} />  Provider: {currentProvider.providersObj.name} | <FontAwesomeIcon icon={faHouseChimneyUser} style={{ ...iconsStyles }}/> Farm: {currentProvider.providersObj.farm} | <FontAwesomeIcon icon={faLocationPin} style={{ ...iconsStyles }}/> Location: {currentProvider.providersObj.location} | <FontAwesomeIcon icon={faTextHeight} style={{ ...iconsStyles }}/> height: {currentProvider.providersObj.height} </span><br/>
                </div>
              </div>
                { currentProvider && currentProvider.providersObj && currentProvider.providersObj.products && currentProvider.providersObj.products.map((item, index) => (
                  <div key={index} style={{ ...generalStyleDivs, ...decorationOfCards, display: "flex", flexFlow: "row", alignItems: "center" }}>
                      <div  style={{width: "30%", display: "flex", justifyContent: "center" }}>
                        <img src={item.logoURL} style={{ maxWidth: "95%", maxHeight: "95%", borderRadius: "20px 0px 20px 0px" }} alt='' />
                      </div>
                      <div style={{width: "35%", display: "flex", flexFlow: "column", alignItems: "left", ...styleDesktop, paddingTop: "10px", paddingBottom: "5px", height: "100%", justifyContent: "space-around"  }}>
                          <div className="parentDiv" style={{ padding: "5px" }}><FontAwesomeIcon icon={faMortarPestle} style={{ ...iconsStyles }}/> Grind Type: {item.grindType}</div>
                          <div className="parentDiv" style={{ padding: "5px" }}><FontAwesomeIcon icon={faFireFlameCurved} style={{ ...iconsStyles }}/> Toast: {item.toast}</div>
                          <div className="parentDiv" style={{ padding: "5px" }}><FontAwesomeIcon icon={faLeaf} style={{ ...iconsStyles }}/> Variety: {item.variety}</div>
                          <div className="parentDivNoLine" style={{ display: "flex",flexFlow: "row", alignItems: "center" }}><FontAwesomeIcon icon={faMugHot} style={{ ...iconsStyles }}/> Notes: <div>{parseList(item.notes)}</div></div>
                      </div>
                      <div style={{width: "35%", display: "flex", flexFlow: "column", alignItems: "left", ...styleDesktop, paddingTop: "10px", paddingBottom: "5px", height: "100%", justifyContent: "space-around" }}>
                        <div className="parentDiv" style={{ padding: "5px" }}><FontAwesomeIcon icon={faTags} style={{ ...iconsStyles }}/> Price: {item.price}</div>
                        <div className="parentDiv" style={{ padding: "5px" }}><FontAwesomeIcon icon={faWeightHanging} style={{ ...iconsStyles }}/> Weight: {item.weight}</div>
                        <div className="parentDiv" style={{ padding: "5px" }}><FontAwesomeIcon icon={faBoxOpen} style={{ ...iconsStyles }}/> Type of Pack: {item.typeOfPack}</div>
                        <div className="parentDivNoLine"><FontAwesomeIcon icon={faBoxesStacked} style={{ ...iconsStyles }}/> Stock: <InStock isStock={item.isStock}/></div>
                      </div>
                  </div>
                ))
                }
          
              <div style={{ width: "100%", display: "flex", flexFlow: "row", justifyContent: "space-around" }} >
                {currentProvider && currentProvider.providersObj && currentProvider.providersObj.images && currentProvider.providersObj.images.map((item, index) => (
                  <div key={index} style={{ width: "25%", textAlign: "center" }}>
                    <img 
                      key={index} 
                      src={item.url} 
                      alt='' 
                      style={{ 
                        width: '95%',
                        objectFit: 'contain',
                        maxWidth: '95%',
                        borderRadius: "20px"
                      }} 
                    />
                  </div>
                ))}
              </div>
              
            </div>
          </div>
          </>
        }
        {currentProvider != null && isSmallScreen && 
          <>
          <div id="mainDiv" style={{ backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat", paddingTop: "10px", paddingLeft: "10px", paddingRight: "10px" }}>
            <div style={{ ...generalStyleDivs }}>
              <div style={{ display: "flex", flexFlow: "column", alignItems: "center"}}>
                <img src={currentProvider.providersObj.logoURL} style={{  maxWidth: "90%", borderRadius: "20px" }} alt='' />
                <div style={{ width: "90%", marginBottom: "15px",paddingTop: "10px" }}>
                  <div><FontAwesomeIcon icon={faUser} style={{ ...iconsStyles }} />  Provider: {currentProvider.providersObj.name}</div><br/> 
                  <div><FontAwesomeIcon icon={faHouseChimneyUser} style={{ ...iconsStyles }}/> Farm: {currentProvider.providersObj.farm}</div><br/>
                  <div><FontAwesomeIcon icon={faLocationPin} style={{ ...iconsStyles }}/> Location: {currentProvider.providersObj.location}</div><br/>
                  <div><FontAwesomeIcon icon={faTextHeight} style={{ ...iconsStyles }}/> height: {currentProvider.providersObj.height}</div><br/>
                </div>
              </div>
            </div>
            <div style={{ display: "flex", flexFlow: "column", ...generalStyleDivs, padding: "10px", lineHeight: 1.5, ...sizeFont, ...mobileSpacing }}>
              <div className="parentDiv" style={{ paddingBottom: "10px" }}>{currentProvider.providersObj.smallDescription}</div>
              <div>{currentProvider.providersObj.description}</div>
            </div>
            <div id="productsArea" style= {{ ...mobileSpacing, paddingBottom: "10px" }}>
              { currentProvider && currentProvider.providersObj && currentProvider.providersObj.products && currentProvider.providersObj.products.map((item, index) => (
                  <div key={index} style={{ ...generalStyleDivs}}>
                    <div style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}>
                      <img src={item.logoURL} style={{ maxWidth: "90%", borderRadius: "20px"  }} alt='' />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ ...sizeFont, paddingTop: "5px", paddingLeft: "20px" }} >
                        <div><FontAwesomeIcon icon={faMortarPestle} style={{ ...iconsStylesMovile }}/> Grind Type: {item.grindType}</div><br/>
                        <div ><FontAwesomeIcon icon={faFireFlameCurved} style={{ ...iconsStylesMovile }}/> Toast: {item.toast}</div><br/>
                        <div ><FontAwesomeIcon icon={faLeaf} style={{ ...iconsStylesMovile }}/> Variety: {item.variety}</div><br/>
                        <div style={{ display: "flex", flexFlow: "row", alignItems: "center" }}><FontAwesomeIcon icon={faMugHot} style={{ ...iconsStylesMovile }}/> Notes: <div>{parseList(item.notes)}</div></div><br/>
                        <div ><FontAwesomeIcon icon={faTags} style={{ ...iconsStylesMovile }}/> Price: {item.price}</div><br/>
                        <div ><FontAwesomeIcon icon={faWeightHanging} style={{ ...iconsStylesMovile }}/> Weight: {item.weight}</div><br/>
                        <div ><FontAwesomeIcon icon={faBoxOpen} style={{ ...iconsStylesMovile }}/> Type of Pack: {item.typeOfPack}</div><br/>
                        <div><FontAwesomeIcon icon={faBoxesStacked} style={{ ...iconsStylesMovile }}/> Stock: <InStock isStock={item.isStock}/></div><br/>
                      </div>
                    </div>
                </div>
              ))
              }
            </div>
            <div style= {{ ...mobileSpacing }}>
              <CarroucelImg carroucelImg={currentProvider.providersObj.images} isSmallScreen={true} isLargeScreen={false}  arrows="black" />
            </div>
          </div>

          </>
        }

        </>
      }
      <Footer />
    </>
  )

}
function InStock(prop) {
  let inStockStr = "";
  if (prop.isStock) {
    inStockStr = "In Stock";
  } else {
    inStockStr = "Out of Stock";
  }


  let styleForStock = {};
  if (prop.isStock) {
    styleForStock = {
     color: "green"
    }
  } else {
    styleForStock = {
      color: "red"
    }
  }
  return (
    <>
      <span style={{ ...styleForStock }}>  {inStockStr} </span>
    </>
  )
}

export default OurProvidersPage;

